import React, { useState } from 'react';
import './style.scss';

type DropdownOption<T> = {
  label: string;
  value: T;
};

type DropdownProps<T extends string> = {
  disabled?: boolean;
  options: Array<DropdownOption<T>>;
  value: T;
  onSelect?: (value: T) => void;
};

const Dropdown = <T extends string>({ disabled, options, value, onSelect }: DropdownProps<T>) => {
  const [selectedValue, setSelectedValue] = useState(value);

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setSelectedValue(selectedValue as T);

    if (onSelect) {
      onSelect(selectedValue as T);
    }
  };

  return (
    <div className="dropdown">
      <select value={selectedValue} onChange={handleSelectChange} disabled={disabled}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
